import Select from 'react-select';

export interface GenericOptions<T> {
  label: string;
  value: T;
}

interface Props<T> {
  defaultValue?: T;
  value: T;
  options: readonly GenericOptions<T>[];
  onChange: (value: T) => void;
  disabled?: boolean;
}

/*
 * Generic React Select component
 * purpose is to provide a generic select component that can be used in place of the default select component
 */
export function ReactSelect<T>(props: Props<T>) {
  return (
    <Select
      defaultValue={props.options.find((option) => option.value === props.defaultValue)}
      options={props.options}
      isSearchable={false}
      isClearable={true}
      classNames={{
        // control: () => 'bg-dark border-dark'
        // option: () => 'bg-dark'
        multiValue: () => 'text-white',
        input: () => 'text-white',
        valueContainer: () => 'text-white',
        singleValue: () => 'text-white'
        // : () => 'bg-dark'
      }}
      onChange={async (e) => {
        if (e) {
          props.onChange(e.value);
        }
      }}
      styles={{
        control: (provided) => ({
          ...provided,
          backgroundColor: '#515151',
          borderColor: '#515151',
          color: 'white'
        }),
        option: (provided, options) => ({
          ...provided,
          backgroundColor: options.isFocused ? '#8c8c8c' : '#515151',
          color: 'white'
        }),
        groupHeading: (provided) => ({
          ...provided,
          color: 'white'
        }),
        menuList: (provided) => ({
          ...provided,
          backgroundColor: '#515151',
          color: 'white'
        })
      }}
      isDisabled={props.disabled ?? false}
    />
  );
}
